/**
 * Copyright 2025 Paion Data. All rights reserved.
 */
import "./LanguageButton.css";
import { selectLanguage, setLanguage, useAppDispatch, useAppSelector } from "studytour-io-redux";
import { BULGARIAN, CHINESE, ENGLISH } from "studytour-io-redux/src/appSlice";
import { i18n } from "studytour-io-i18n";

export default function LanguageButton(): JSX.Element {
  const dispatch = useAppDispatch();
  const language = useAppSelector(selectLanguage);

  const allLanguages = [ENGLISH, CHINESE, BULGARIAN];
  const languageToCode = new Map([
    [ENGLISH, "en"],
    [CHINESE, "zh"],
    [BULGARIAN, "bg"],
  ]);

  return (
    <div className="language-dropdown">
      <div className="trigger">
        <span>{language}</span>
        <ul className="languages">
          {allLanguages
            .filter((it) => it !== language)
            .map((it) => {
              return (
                <li
                  onClick={() => {
                    dispatch(setLanguage(it));
                    void i18n.changeLanguage(languageToCode.get(it));
                  }}
                  key={it}
                >
                  {it}
                </li>
              );
            })}
        </ul>
      </div>
    </div>
  );
}
